import { PlcSupportData, PlcTableFilterSettings, PlcViewModel } from './models'

export interface SelectPlcUiState {
  interacted: boolean
  filterSettings: PlcTableFilterSettings
  numberOfMessagesInQueue: number
  supportData: PlcSupportData
  showMassUpdateEcoCloudConnector: PlcViewModel[]
}

export enum SelectPlcUiAction {
  initialize = 'initialize',
  migratePlcToEcoCloudConnector = 'migratePlcToEcoCloudConnector',
  updateToLatestEcoCloudConnector = 'updateToLatestEcoCloudConnector',
  massUpdateToLatestEcoCloudConnector = 'massUpdateToLatestEcoCloudConnector',
  updateToLatestInTestEcoCloudConnectorVersion = 'updateToLatestInTestEcoCloudConnectorVersion',
  updateTrumpfInverterFirmware = 'updateTrumpfInverterFirmware',
  restartEcoCloudConnector = 'restartEcoCloudConnector',
  restartPlc = 'restartPlc',
  resetPlcConfigurationRelease = 'resetPlcConfigurationRelease',
  collectSupportData = 'collectSupportData',
  loadFilterSettings = 'loadFilterSettings',
  updateFilterSettings = 'updateFilterSettings',
  askForMassUpdateEcoCloudConnector = 'askForMassUpdateEcoCloudConnector',
}

export enum SelectPlcUiMutation {
  setInteracted = 'setInteracted',
  setNumberOfMessagesInQueue = 'setNumberOfMessagesInQueue',
  setSupportData = 'setSupportData',
  setAskForMassUpdateEcoCloudConnector = 'setAskForMassUpdateEcoCloudConnector',
}

export enum SelectPlcUiGetter {
  isInteracted = 'isInteracted',
  filterSettings = 'filterSettings',
  plcs = 'plcs',
  projects = 'projects',
  plcTypes = 'plcTypes',
  versions = 'versions',
  statuses = 'statuses',
  alarms = 'alarms',
  filteredPlcs = 'filteredPlcs',
  trumpfInverterFirmwareVersions = 'trumpfInverterFirmwareVersions',
  numberOfMessagesInQueue = 'numberOfMessagesInQueue',
  activeEccReleaseVersion = 'activeEccReleaseVersion',
  latestTestEccReleaseVersion = 'latestTestEccReleaseVersion',
  supportData = 'supportData',
  massUpdateEcoCloudConnectorAvailable = 'massUpdateEcoCloudConnectorAvailable',
  plcsForMassUpdateEcoCloudConnector = 'plcsForMassUpdateEcoCloudConnector',
}
